import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export class TokenInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const apiIpify = environment.clienteIp;
        if ( req.url.indexOf(apiIpify) === -1) {
            const identificadorSeguridad = sessionStorage.getItem('identificadorSeguridad') ?
            sessionStorage.getItem('identificadorSeguridad') : '';
            const obj = JSON.parse(sessionStorage.getItem('informacionbasica'));
            const numeroIdentificacion = obj ?
            obj.numeroDocumento : '';
            if ( identificadorSeguridad) {
                const authReq = req.clone({
                    headers: req.headers.set('numeroIdentificacion', numeroIdentificacion).
                    set('identificadorSeguridad', identificadorSeguridad)
                });
                return next.handle(authReq);
            }
        } else {
            if (req.headers.has('Content-Type')) {
                req = req.clone({ headers: req.headers.delete('Content-Type','application/json') });
            }
        }
        return next.handle(req);
    }
}
